<template>
  <div class="chatbot-qa">
    <AskQuestion v-if="message.userInput" :question="message.userInput"/>
    <GetAnswer v-if="message.answer" :answer="message.answer" :isMultiQuestion="message.isMultiQuestion" :history="message.history" :last-item="lastItem" />      
    <div class="clear-float"></div>
    <EndQA v-if="message.over" :last-item="lastItem" :history="message.history" />
  </div>
</template>

<script>
import GetAnswer from '@/components/GetAnswer'
import AskQuestion from '@/components/AskQuestion'
import EndQA from '@/components/EndQA'
export default {
  name: 'ChatbotQA',
  data(){
    return {
      chatHead:'/static/images/chat-head.png',
    }
  },
  components:{
    AskQuestion, 
    GetAnswer,
    EndQA
  },
  watch:{
  },
  props:{
    message: Object,
    lastItem: Boolean,
  }
}
</script>

<style>
.clear-float {
  clear:both;
}
</style>
